export enum UserMessageColor {
  blue = 'primary',
  orange = 'warning',
  green = 'success',
  red = 'danger',
  white = 'light',
}
